import { appRoutes } from '../../path';
import EmbeddedChart from '../../components/Chart/EmbeddedChart';
import EmbeddedDashboardView from '../DashboardRoute/DashboardInstance/EmbeddedDashboardView/EmbeddedDashboardView';
import { RouteObject } from 'react-router-dom';
import EmbeddedRoutesWrapper from './EmbedRoutesWrapper';

const embedRoutes: RouteObject[] = [
  {
    path: appRoutes.embed.report(':reportType', ':reportId'),
    element: <EmbeddedChart type="report" />,
  },
  {
    path: appRoutes.embed.dashboard(':dashboardBaseId'),
    element: <EmbeddedDashboardView />,
  },
  {
    path: appRoutes.embed.dashboard(':dashboardBaseId', ':instanceId'),
    element: <EmbeddedDashboardView />,
  },
  {
    path: appRoutes.embed.cohort(':cohortId'),
    element: <EmbeddedChart type="cohort" />,
  },
];

const embedRoute = {
  element: <EmbeddedRoutesWrapper />,
  children: embedRoutes,
};

export default embedRoute;
